.root {
    display: flex;
    gap: var(--labui-grid-gap);
}

.item {
    flex: 1 0 calc(50% - var(--labui-grid-gap) / 2);
    margin: 0;
}

.mediaWrapper {
    height: auto;
}

.media {
    width: 100%;
    height: auto;
}

.caption {
    margin-top: var(--spacer-12);
    font: var(--font-s-14);
}
